/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
    var element = document.querySelectorAll('#MobileNav--boutique-0 .mobile-nav__trigger--level-2');
    for (var i = 0; i <= 0; i++) {
      element[i].className += ' is-expanded';
      element[i].nextElementSibling.className += ' is-expanded';
      element[i].nextElementSibling.style.height = "auto";
    }
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
